import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SearchSectionNode from '@Pages/QueryBuilder/SearchSection/SearchSectionNode/SearchSectionNode';

function HistoryTab({ nodes, getHistoryItems, addToBuilder }) {
  useEffect(() => {
    if (isEmpty(nodes)) {
      getHistoryItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="query-builder-search-section__history-tab">
      {nodes.length > 0 ? (
        nodes.map((node, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SearchSectionNode node={node} level={0} index={index} key={`level-0-index-${index}`} addToBuilder={addToBuilder} />
        ))
      ) : (
        <div className="query-builder-search-section__empty-tab">
          <div className="query-builder-search-section__empty-tab-pic" />
          {/* <svg className="query-builder-search-section__empty-tab-pic">
            <use xlinkHref="#assets-manuscript" />
          </svg> */}
          <strong className="query-builder-search-section__empty-tab-short-msg">There are no recent or saved searches yet.</strong>
          <div className="query-builder-search-section__empty-tab-long-msg">
            Start searching and saving your favorite searches. We’ll store them here for easy access.
          </div>
        </div>
      )}
    </div>
  );
}

HistoryTab.propTypes = {
  nodes: PropTypes.array.isRequired,
  getHistoryItems: PropTypes.func.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default HistoryTab;
